export default __webpack_public_path__ + "static/media/km1.7da41806.png";